"use strict";
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const theme_1 = require("../../theme");
const text_component_1 = require("../text/text.component");
const checkmark_component_1 = require("../support/components/checkmark.component");
const minus_component_1 = require("../support/components/minus.component");
const services_1 = require("../support/services");
/**
 * Styled `CheckBox` component.
 *
 * @extends React.Component
 *
 * @property {boolean} checked - Determines whether component is checked.`
 * Default is `false`.
 *
 * @property {boolean} disabled - Determines whether component is disabled.
 * Default is `false.
 *
 * @property {string} status - Determines the status of the component.
 * Can be `basic`, `primary`, `success`, `info`, `warning`, `danger` or `control`.
 * Default is `basic`.
 *
 * @property {string} text - Determines text of the component.
 *
 * @property {StyleProp<TextStyle>} textStyle - Customizes text style.
 *
 * @property {(checked: boolean) => void} onChange - Fires on checkbox value change.
 *
 * @property {TouchableOpacityProps} ...TouchableOpacityProps - Any props applied to TouchableOpacity component.
 *
 * @overview-example CheckboxSimpleUsage
 *
 * @overview-example CheckboxStates
 *
 * @overview-example CheckboxIndeterminate
 *
 * @overview-example CheckboxStatus
 *
 * @example CheckboxInlineStyling
 */
class CheckBoxComponent extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.webEventResponder = services_1.WebEventResponder.create(this);
        // WebEventResponderCallbacks
        this.onMouseEnter = () => {
            this.props.dispatch([theme_1.Interaction.HOVER]);
        };
        this.onMouseLeave = () => {
            this.props.dispatch([]);
        };
        this.onFocus = () => {
            this.props.dispatch([theme_1.Interaction.FOCUSED]);
        };
        this.onBlur = () => {
            this.props.dispatch([]);
        };
        this.onPress = () => {
            this.props.dispatch([]);
            if (this.props.onChange) {
                this.props.onChange(!this.props.checked, false);
            }
        };
        this.onPressIn = (event) => {
            this.props.dispatch([theme_1.Interaction.ACTIVE]);
            if (this.props.onPressIn) {
                this.props.onPressIn(event);
            }
        };
        this.onPressOut = (event) => {
            this.props.dispatch([]);
            if (this.props.onPressOut) {
                this.props.onPressOut(event);
            }
        };
        this.getComponentStyle = (source) => {
            const { textMarginHorizontal, textFontFamily, textFontSize, textFontWeight, textLineHeight, textColor, iconWidth, iconHeight, iconBorderRadius, iconTintColor, outlineWidth, outlineHeight, outlineBorderRadius, outlineBackgroundColor, ...containerParameters } = source;
            return {
                container: {},
                highlightContainer: {},
                selectContainer: containerParameters,
                text: {
                    marginHorizontal: textMarginHorizontal,
                    fontFamily: textFontFamily,
                    fontSize: textFontSize,
                    fontWeight: textFontWeight,
                    lineHeight: textLineHeight,
                    color: textColor,
                },
                icon: {
                    width: iconWidth,
                    height: iconHeight,
                    fill: iconTintColor,
                    stroke: iconTintColor,
                    strokeWidth: 3,
                },
                highlight: {
                    width: outlineWidth,
                    height: outlineHeight,
                    borderRadius: outlineBorderRadius,
                    backgroundColor: outlineBackgroundColor,
                },
            };
        };
        this.createHitSlopInsets = (style) => {
            const { width } = react_native_1.StyleSheet.flatten(style);
            // @ts-ignore: `width` is restricted to be a number
            const value = 40 - width;
            return {
                left: value,
                top: value,
                right: value,
                bottom: value,
            };
        };
        this.renderTextElement = (style) => {
            const { text, textStyle } = this.props;
            return (react_1.default.createElement(text_component_1.Text, { style: [style, styles.text, textStyle] }, text));
        };
        this.renderIconElement = (style) => {
            const Icon = this.props.indeterminate ? minus_component_1.Minus : checkmark_component_1.CheckMark;
            return (react_1.default.createElement(Icon, Object.assign({}, style)));
        };
        this.renderComponentChildren = (style) => {
            const { text } = this.props;
            return [
                this.renderIconElement(style.icon),
                services_1.isValidString(text) && this.renderTextElement(style.text),
            ];
        };
    }
    render() {
        const { themedStyle, style, disabled, text, ...derivedProps } = this.props;
        const { container, highlightContainer, highlight, selectContainer, ...componentStyle } = this.getComponentStyle(themedStyle);
        const selectContainerStyle = [selectContainer, styles.selectContainer];
        const hitSlopInsets = this.createHitSlopInsets(selectContainerStyle);
        const [iconElement, textElement] = this.renderComponentChildren(componentStyle);
        return (react_1.default.createElement(react_native_1.TouchableOpacity, Object.assign({ activeOpacity: 1.0 }, derivedProps, this.webEventResponder.eventHandlers, { style: [container, styles.container, webStyles.container, style], disabled: disabled, hitSlop: hitSlopInsets, onPress: this.onPress, onPressIn: this.onPressIn, onPressOut: this.onPressOut }),
            react_1.default.createElement(react_native_1.View, { style: [highlightContainer, styles.highlightContainer] },
                react_1.default.createElement(react_native_1.View, { style: [highlight, styles.highlight] }),
                react_1.default.createElement(react_native_1.View, { style: selectContainerStyle }, iconElement)),
            textElement));
    }
}
CheckBoxComponent.styledComponentName = 'CheckBox';
const styles = react_native_1.StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    highlightContainer: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    selectContainer: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    highlight: {
        position: 'absolute',
    },
    icon: {},
    text: {},
});
const webStyles = react_native_1.Platform.OS === 'web' && react_native_1.StyleSheet.create({
    container: {
        // @ts-ignore
        outlineWidth: 0,
    },
});
exports.CheckBox = theme_1.styled(CheckBoxComponent);
//# sourceMappingURL=checkbox.component.js.map